<template>
  <section :class="wrapperClasses" class="mds-card-v2">
    <header>
      <!-- @slot Слот заголовка карточки-->
      <slot name="header"/>

      <div class="buttons-wrap">
        <slot name="toolbar" />

        <button
            class="btn-edit"
            @click.stop="$emit('edit-button:clicked')"
        >
          <VIcon material="edit"/>
        </button>

        <VContextMenuButton
            v-if="showContextMenuButton"
            theme="link"
            icon="menu"
        >
          <slot name="context-menu" />
        </VContextMenuButton>

        <button @click.stop="onCloseButtonClick" class="btn-close">
          <VIcon material="close"/>
        </button>
      </div>
    </header>

    <div :class="contentClasses" class="content">
      <!-- @slot Слот контента карточки-->
      <slot/>
    </div>

    <footer>
      <!-- @slot Слот футера карточки-->
      <slot name="footer"/>

      <VButton class="btn-close-footer" @click.stop="onCloseButtonClick">
        Закрыть
      </VButton>
    </footer>
  </section>
</template>

<style lang="scss" src="./VCardV2.scss"/>

<script lang="ts">

export default defineComponent({
  name: 'VCard',

  props: {
    /**
     * Отключение внутренних отступов контента карточки
     */
    noPadding: {
      type: Boolean,
      default: false,
    },
    /**
     * Показать кнопку редактирования (карандаш) в тулбаре хедера
     */
    // showEditButton: {
    //   type: Boolean,
    //   default: true,
    // },
    /**
     * Показать кнопку контекстного меню (кебаб) в тулбаре хедера
     */
    showContextMenuButton: {
      type: Boolean,
      default: true,
    },
    /**
     * Причина блокировки кнопки редактирования.
     * Если указана — кнопка disabled + тултип с причиной.
     * Если null — кнопка активна.
     */
    // editButtonDisabledReason: {
    //   type: String,
    //   default: null,
    // },
  },

  emits: ['close-button:clicked', 'edit-button:clicked'],

  data() {
    return {};
  },

  computed: {
    wrapperClasses() {
      return {
        'no-padding': this.noPadding,
      };
    },

    contentClasses() {
      return {
        'with-footer': this.haveFooterSlot,
        'with-header': this.haveHeaderSlot,
      };
    },

    haveHeaderSlot(): boolean {
      return this.$slots['header'] !== undefined;
    },

    haveFooterSlot(): boolean {
      return this.$slots['footer'] !== undefined;
    },

    haveContextMenuSlot(): boolean {
      return this.$slots['context-menu'] !== undefined;
    },
  },

  methods: {
    onCloseButtonClick() {
      this.$emit('close-button:clicked');
    },
  },
});
</script>
